import { render, staticRenderFns } from "./StoryPathCard.vue?vue&type=template&id=76a8760a&"
import script from "./StoryPathCard.vue?vue&type=script&lang=ts&"
export * from "./StoryPathCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports